"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V3_TOKENS = exports.V2_TOKENS = void 0;
var V2_TOKENS = {
  fontWeight: "bold",
  color: "black60",
  bg: "black10",
  xxs: {
    diameter: 30,
    variant: "text"
  },
  xs: {
    diameter: 45,
    variant: "text"
  },
  sm: {
    diameter: 70,
    variant: "title"
  },
  md: {
    diameter: 100,
    variant: "largeTitle"
  }
};
exports.V2_TOKENS = V2_TOKENS;
var V3_TOKENS = {
  fontWeight: "normal",
  color: "black100",
  bg: "transparent",
  xxs: {
    diameter: 30,
    variant: "xs"
  },
  xs: {
    diameter: 45,
    variant: "xs"
  },
  sm: {
    diameter: 70,
    variant: "md"
  },
  md: {
    diameter: 100,
    variant: "lg"
  }
};
exports.V3_TOKENS = V3_TOKENS;